import Vue from 'vue'
import VueI18n from 'vue-i18n'
import fr from '@/lang/fr.json'
import en from '@/lang/en.json'

Vue.use(VueI18n)

const locale = 'fr'
const messages = {
  fr,
  en
}
const i18n = new VueI18n({
  locale,
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js